export default function NarrowPage({ title = null, icon = null, children }) {
  return (
    <div className="flex flex-1 items-start justify-center bg-altgray-50">
      <div className="w-full p-0 flex flex-col md:p-5 md:w-[522px]">
        <div className="flex flex-col text-altgray-900 text-[140%] font-semibold py-5 items-center">
          <div className="flex flex-row items-center">
            {icon && <span className="text-altgray-600 mr-2.5">{icon}</span>}{" "}
            {title}
          </div>
        </div>
        <div className="p-10 flex mb-20 flex-col bg-white border border-b-[3px] md:rounded-lg md:p-10">
          {children}
        </div>
      </div>
    </div>
  );
}


